import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgAddIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g clipPath="url(#add-icon_svg__a)">
      <path
        fill="currentColor"
        d="M15.03 15.03c-9.373 9.372-9.373 24.568 0 33.94 9.373 9.373 24.568 9.373 33.941 0s9.373-24.568 0-33.94c-9.373-9.373-24.568-9.373-33.941 0m-1.886 35.826c-10.414-10.414-10.414-27.298 0-37.712s27.299-10.414 37.713 0 10.414 27.298 0 37.712-27.299 10.414-37.713 0m17.523-17.523H16.916v-2.666h13.751V16.915h2.667v13.752h13.751v2.666H33.334v13.752h-2.667z"
      />
    </g>
    <defs>
      <clipPath id="add-icon_svg__a">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgAddIcon
